import { render, staticRenderFns } from "./ShareDescInfo.vue?vue&type=template&id=2655af1b&scoped=true"
import script from "./ShareDescInfo.vue?vue&type=script&lang=js"
export * from "./ShareDescInfo.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2655af1b",
  null
  
)

export default component.exports